// Testimonials - Data source
// Client testimonials and reviews
// Note: adventure and text content should be fetched from translations using translationKey

export interface Testimonial {
  id: string;
  translationKey: string; // Key to lookup in translations: testimonials.items.[key]
  name: string;
  location: string;
  date: string;
  rating: number;
  image: string;
  featured: boolean;
}

export const testimonials: Testimonial[] = [
  {
    id: "sarah-wilson-heli-skiing",
    translationKey: "sarahWilson",
    name: "Sarah Wilson",
    location: "Aspen, Colorado",
    date: "July 2024",
    rating: 5.0,
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&q=80",
    featured: true,
  },
  {
    id: "james-mitchell-fly-fishing",
    translationKey: "jamesMitchell",
    name: "James Mitchell",
    location: "Montana, USA",
    date: "November 2024",
    rating: 5.0,
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&q=80",
    featured: true,
  },
  {
    id: "emma-rodriguez-ski-touring",
    translationKey: "emmaRodriguez",
    name: "Emma Rodriguez",
    location: "Barcelona, Spain",
    date: "August 2024",
    rating: 5.0,
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&q=80",
    featured: true,
  },
  {
    id: "david-chen-premium-lodge",
    translationKey: "davidChen",
    name: "David Chen",
    location: "Vancouver, Canada",
    date: "September 2024",
    rating: 4.8,
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&q=80",
    featured: false,
  },
  {
    id: "marie-laurent-cat-skiing",
    translationKey: "marieLaurent",
    name: "Marie Laurent",
    location: "Chamonix, France",
    date: "June 2024",
    rating: 5.0,
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&q=80",
    featured: true,
  },
  {
    id: "robert-thompson-custom-adventure",
    translationKey: "robertThompson",
    name: "Robert Thompson",
    location: "Sydney, Australia",
    date: "January 2025",
    rating: 4.9,
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&q=80",
    featured: false,
  },
];

export function getTestimonialById(id: string): Testimonial | undefined {
  return testimonials.find((testimonial) => testimonial.id === id);
}

export function getFeaturedTestimonials(): Testimonial[] {
  return testimonials.filter((testimonial) => testimonial.featured);
}
